/// <reference path="appbase.ts" />

namespace TerminalApp {



    class ArrivalElement {
        index: number = 0;
        renderedIndex: number = 0;
        data: SP.ArrivalInfo;
        html: HTMLElement;
        menu: SP.SwipeMenu;


        constructor(data: SP.ArrivalInfo) {
            this.data = data;

            var icon = data.arrivalType == SP.ArrivalType.Return || data.arrivalType == SP.ArrivalType.InternalReturn ? "/terminal/img/icon/return-box.png" : data.arrivalType == SP.ArrivalType.Audit ? "/terminal/img/icon/audit-box.png" : "/terminal/img/icon/open-box.png";

            var locInfo = data.arrivalLocation ? `(${data.arrivalLocation})` : "";
            this.html = CreateButton(icon, `${data.stockName} ${locInfo}<br><span style='font-size:15px;'>${data.arrivalSender} <span class='regular'>${data.arrivalReferenceNo}</span></span>`);
            this.html.classList.add("full");

            var timeText = document.createElement("div");
            timeText.classList.add("text", "top", "right");
            timeText.innerHTML = `${data.arrivalDate} <span class="regular">${data.arrivalTime}</span>`;
            this.html.appendChild(timeText);
            //;
            var statusText = document.createElement("div");
            statusText.classList.add("text", "bottom", "right");
            statusText.style.bottom = "9px";
            var statusColor = data.itemsArrived == data.itemsExpected ? "" : "style='background-color: #eba537'";
            statusText.innerHTML = `<span class="label" ${statusColor}><b>${data.itemsArrived} / ${data.itemsExpected ? data.itemsExpected : "-"}</b></span>`;
            this.html.appendChild(statusText);

            if (data.arrivalFinished) {
                this.html.classList.add("faded");
                this.html.addEventListener("click", () => { GetApp("app_arrival_show").open({ id: this.data.arrivalId }) });
            }
            else {
                this.menu = new SP.SwipeMenu(
                    /*Element*/
                    this.html,

                    /*Click Event*/
                    () => { GetApp("app_arrival_show").open({ id: this.data.arrivalId }) },

                    /*buttons*/
                    [
                    /*Edit Button  */{ icon: "<i class='fas fa-edit'></i>", text: SP.Localize("word_edit"), color: "#359ee8", confirm: false, action: async () => { SP.setAllHash({ "app": "app_arrival_create", "id": this.data.arrivalId }) } },
                    /*Finish Button*/{
                            icon: "<i class='fas fa-check'></i>", text: SP.Localize("word_finish"), color: "#5ce835", confirm: true, action: async () => {
                                var result = await SP.get<any>("/api/v1/arrival/finish/" + this.data.arrivalId);
                                if (result.status == 200) {
                                    SP.Sounds.Success.play();
                                }
                                else {
                                 
                                    this.menu.return();
                                    await SP.alertX(`${result.status}: ${result.msg}`);
                                    if (result.exception) { console.log(result.exception); }
                                }
                            }
                        }
                    ],
                    /*group*/
                    "app_arrival"
                );
            }
        }
    }

    class ArrivalAssistant {
        container = document.createElement("div");
        home_menu = document.createElement("div");
        stock_menu = document.createElement("div");
        po_menu = document.createElement("div");
        sender_menu = document.createElement("div");
        reference_menu = document.createElement("div");
        location_menu = document.createElement("div");
        front_po_suggestion_container = document.createElement("div");
        stock_suggestion_container = document.createElement("div");
        po_suggestion_container = document.createElement("div");
        sender_suggestion_container = document.createElement("div");
        locations_container = document.createElement("div");

        sender_input = document.createElement("input");
        reference_number_input = document.createElement("input");
        sender_reference_number_input = document.createElement("input");
        customer_name_input = document.createElement("input");
        customer_name_container = document.createElement("div");

        po_search_input: HTMLInputElement;

        create_button: HTMLElement;
        error: HTMLElement;

        initialized = false;
        stockButtons: HTMLElement[] = [];

        result_barcode: string;
        result_sender: string;
        result_reference: string;
        result_sender_reference: string;
        result_arrival_location: string;
        result_customer: string;
        result_purchase_order: SP.purchaseOrderInfo;
        result_arrival_type: SP.ArrivalType;

        constructor() {

            this.container.classList.add("assistant");

            //close button
            var close_button = this.container.appendChild(document.createElement("div"))
            close_button.classList.add("close");
            close_button.innerHTML = "X";
            close_button.addEventListener("click", () => {
                this.close();
            });

            //setup home screen
            var home_headline = this.home_menu.appendChild(document.createElement("h1"));
            home_headline.innerHTML = SP.Localize("word_suggestions");
            this.home_menu.append(this.front_po_suggestion_container);
            this.addArrivalButton();
            this.addReturnButton();
            this.addAuditButton();
            this.addInternalReturnButton();
            this.container.appendChild(this.home_menu);

            //setup stock screen
            var stock_headline = this.stock_menu.appendChild(document.createElement("h1"));
            stock_headline.innerHTML = SP.Localize("sentance_pick_stock");
            this.stock_menu.append(this.stock_suggestion_container);
            this.container.appendChild(this.stock_menu);

            //setup pending screen
            var po_headline = this.po_menu.appendChild(document.createElement("h1"));
            po_headline.innerHTML = SP.Localize("sentance_select_purchase_order");


            //search
            var po_search_input = this.po_search_input = document.createElement("input");
            po_search_input.type = "text";
            po_search_input.placeholder = SP.Localize("sentance_search_purchase_order") + " ...";
            po_search_input.autocomplete = "off";
            po_search_input.tabIndex = 1;
            po_search_input.classList.add("search_input", "form-control");
            this.po_menu.append(po_search_input);

            var timeout: any = null;
            po_search_input.addEventListener("input", () => {
                var keyword = po_search_input.value;
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.search_purchace_orders(keyword);
                }, 1000);
            });


            this.po_menu.append(this.po_suggestion_container);
            this.container.appendChild(this.po_menu);

            var manualButton = this.po_menu.appendChild(document.createElement("div"));
            manualButton.classList.add("btn", "grad-green", "noselect");
            manualButton.innerHTML = `<span class="action">${SP.Localize("sentance_add_manually")}</span>`;
            manualButton.addEventListener("click", () => { this.open_sender_menu() });


            //setup sender screen
            var sender_headline = this.sender_menu.appendChild(document.createElement("h1"));
            sender_headline.innerHTML = SP.Localize("sentance_pick_sender");
            this.sender_input.type = "text";
            this.sender_input.placeholder = SP.Localize("sentance_find_sender") + " ...";
            this.sender_input.autocomplete = "off";
            this.sender_input.tabIndex = 1;
            this.sender_input.classList.add("search_input", "form-control");
            this.sender_input.addEventListener("keyup", () => {
                this.load_senders(this.result_customer, this.sender_input.value);
            });

            this.sender_menu.append(this.sender_input);
            this.sender_menu.append(this.sender_suggestion_container);
            this.container.appendChild(this.sender_menu);


            //setup locations screen
            var location_headline = this.location_menu.appendChild(document.createElement("h1"));
            location_headline.innerHTML = SP.Localize("sentance_pick_arrival_location");
            this.location_menu.append(this.locations_container);
            this.container.appendChild(this.location_menu);



            //setup reference
            var customer_name_headline = this.customer_name_container.appendChild(document.createElement("h1"));
            customer_name_headline.innerHTML = SP.Localize("sentance_customer_name");
            this.customer_name_input.type = "text";
            this.customer_name_input.placeholder = SP.Localize("sentance_customer_name");
            this.customer_name_input.autocomplete = "off";
            this.customer_name_input.tabIndex = 1;
            this.customer_name_input.classList.add("search_input", "form-control");
            this.customer_name_container.append(this.customer_name_input);
            this.reference_menu.append(this.customer_name_container);

            var reference_number_headline = this.reference_menu.appendChild(document.createElement("h1"));
            reference_number_headline.innerHTML = SP.Localize("sentance_reference_number");
            this.reference_number_input.type = "text";
            this.reference_number_input.placeholder = SP.Localize("sentance_reference_number");
            this.reference_number_input.autocomplete = "off";
            this.reference_number_input.tabIndex = 1;
            this.reference_number_input.classList.add("search_input", "form-control", "allow-scan");
            this.reference_menu.append(this.reference_number_input);
            this.container.appendChild(this.reference_menu);

            this.sender_reference_number_input.type = "text";
            this.sender_reference_number_input.placeholder = `${SP.Localize("word_sender")} ${SP.Localize("sentance_reference_number")} (${SP.Localize("word_optional") })`; 
            this.sender_reference_number_input.autocomplete = "off";
            this.sender_reference_number_input.tabIndex = 1;
            this.sender_reference_number_input.classList.add("search_input", "form-control", "allow-scan");
            this.reference_menu.append(this.sender_reference_number_input);


            this.error = this.reference_menu.appendChild(document.createElement("div"));
            this.error.classList.add("error");

            this.create_button = this.reference_menu.appendChild(document.createElement("div"))
            this.create_button.classList.add("btn", "noselect", "grad-green");
            var action = this.create_button.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_create");



            this.create_button.addEventListener("click", async () => {
                this.result_reference = this.reference_number_input.value;
                this.result_sender_reference = this.sender_reference_number_input.value;


                //Open if allready exsist
                let arrivals = App_Arrival.instance.arrivals_sorted;
                console.log(arrivals);
                for (let i = 0; i < arrivals.length; i++) {

                    var d = arrivals[i].data;
                    if (d.arrivalReferenceNo == this.result_reference &&
                        d.arrivalType == this.result_arrival_type &&
                        d.arrivalSender == this.result_sender &&
                        d.arrivalFinished == false &&
                        d.customerId == this.result_customer &&
                        d.arrivalLocation == this.result_arrival_location &&
                        this.result_purchase_order?.id == (d.purchaseOrderId ?? null)) {
                        return GetApp("app_arrival_show").open({ id: d.arrivalId });
                    }
                }

                //take sender from differnt input with RMA
                if (this.result_arrival_type == SP.ArrivalType.Return) {
                    this.result_sender = this.customer_name_input.value;
                }

                var result = await SP.post<any>("/api/v1/arrival/create", {
                    customerId: this.result_customer,
                    sender: this.result_sender,
                    referenceNo: this.result_reference,
                    senderReferenceNo: this.result_sender_reference,
                    arrivalType: this.result_arrival_type,
                    arrivalLocation: this.result_arrival_location,
                    PurchaseOrderId: this.result_purchase_order?.id
                })

                if (result.status != 200) {
                    this.error.innerHTML = result.msg;
                    SP.Sounds.Error.play();
                    this.error.style.display = "block";
                }
                else {
                    SP.Sounds.Success.play();
                    await SP.setAllHash({ app: "app_arrival_show", id: result.arrivalId });
                    if (this.result_barcode) {
                        await SP.sleep(300);
                        await barcodeListener.performScan(this.result_barcode);
                    }
                }
            });


        }


        async load_senders(customerId: string, keyword: string = "") {
            var search_result = await SP.Data.Arrival.findSender(customerId, keyword, 20);
            this.sender_suggestion_container.innerHTML = "";
            var perfectMatch = false;
            keyword = keyword.trim();
            for (let i = 0; i < search_result.length; i++) {
                var n = search_result[i];
                if (n == keyword)
                    perfectMatch = true;
                this.addSenderButton(n, n);
            }

            if (!perfectMatch && keyword.length > 1) {
                this.addSenderButton(keyword + "<br><code>" + SP.Localize("sentance_new_sender") + "?</code>", keyword)
            }
        }

        hide_all_page() {
            this.home_menu.style.display = "none";
            this.stock_menu.style.display = "none";
            this.po_menu.style.display = "none";
            this.sender_menu.style.display = "none";
            this.reference_menu.style.display = "none";
            this.location_menu.style.display = "none";

        }

        open_home_menu() {
            this.hide_all_page();
            this.container.style.display = "block";
            this.home_menu.style.display = "block";
        }

        open_stock_menu() {
            if (this.stockButtons.length == 1) {
                this.stockButtons[0].click();
                return;
            }

            this.hide_all_page();
            this.container.style.display = "block";
            this.stock_menu.style.display = "block";
        }

        async search_purchace_orders(word: string) {
            var paType = this.result_arrival_type == SP.ArrivalType.Standard ? SP.PurchaseOrderType.PurchaseOrder : SP.PurchaseOrderType.ReturnOrder;
            var purchaseOrders = await SP.Data.PurchaseOrder.getPurchaseOrders(this.result_customer, paType, SP.PurchaseOrderState.Ordered, word);

            this.po_suggestion_container.innerHTML = "";
            for (let i = 0; i < purchaseOrders.length; i++) {
                await this.addPurchaseOrder(purchaseOrders[i], true);
            }
        }

        async open_po_menu() {
            //dont look for arrivals if not Standard/Return
            if (this.result_arrival_type != SP.ArrivalType.Return && this.result_arrival_type != SP.ArrivalType.Standard) return this.open_sender_menu();


            await this.search_purchace_orders("");
            if (this.purchaseOrderButtons.length == 0) return this.open_sender_menu();

            //auto click to sender if none

            this.hide_all_page();
            this.container.style.display = "block";
            this.po_menu.style.display = "block";
        }

        async open_location_menu(locations: SP.purchaeOrderLocationInfo[]) {


            //clear container
            this.locations_container.innerHTML = "";



            //add buttons
            for (var i = 0; i < locations.length; i++) {
                var loc = locations[i];
                this.addLocationButton(loc.location, loc.location, loc.totalQty, loc.deliveredQty);
            }

            this.hide_all_page();
            this.container.style.display = "block";
            this.location_menu.style.display = "block";
        }

        open_sender_menu() {
            this.sender_input.value = "";

            //skip sender menu for RMA
            if (this.result_arrival_type != SP.ArrivalType.Standard) {
                this.open_reference_menu();
                return;
            }

            this.hide_all_page();
            this.container.style.display = "block";
            this.sender_menu.style.display = "block";
            this.load_senders(this.result_customer);
        }

        open_reference_menu() {
            this.customer_name_input.value = "";
            this.reference_number_input.value = "";
            this.sender_reference_number_input.value = "";



            //auto fill the reference if purchase order
            if (this.result_purchase_order) {
                this.result_reference = this.result_purchase_order.referenceNo;
                this.reference_number_input.value = this.result_reference;
                this.sender_reference_number_input.focus();
            }


            if (this.result_arrival_type == SP.ArrivalType.Audit) {
                var date = new Date();
                this.reference_number_input.value = "Audit " + date.getDate().toString().padStart(2, "0") + "-" + (date.getMonth() + 1).toString().padStart(2, "0") + "-" + date.getFullYear() + " " + date.getHours().toString().padStart(2, "0") + ":" + date.getMinutes().toString().padStart(2, "0") + ":" + date.getSeconds().toString().padStart(2, "0");
            }

            if (this.result_arrival_type == SP.ArrivalType.InternalReturn) {
                var date = new Date();
                this.reference_number_input.value = "Internal " + date.getDate().toString().padStart(2, "0") + "-" + (date.getMonth() + 1).toString().padStart(2, "0") + "-" + date.getFullYear() + " " + date.getHours().toString().padStart(2, "0") + ":" + date.getMinutes().toString().padStart(2, "0") + ":" + date.getSeconds().toString().padStart(2, "0");
            }

            if (this.result_arrival_type == SP.ArrivalType.Standard) {
                this.reference_number_input.focus();
            }

            if (this.result_arrival_type == SP.ArrivalType.Return) {
                this.customer_name_input.focus();
            }

            this.hide_all_page();
            this.container.style.display = "block";
            this.customer_name_container.style.display = this.result_arrival_type == SP.ArrivalType.Return ? "block" : "none";
            this.reference_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.front_po_suggestion_container.innerHTML = "";
            this.result_barcode = null;
            this.result_sender = null;
            this.result_reference = null;
            this.result_customer = null;
            this.result_purchase_order = null;
            this.result_arrival_type = null;
            this.container.style.display = "none";
            this.home_menu.style.display = "none";
            this.error.style.display = "none";
            this.purchaseOrderButtons = [];
        }

        async init() {
            if (this.initialized) return;

            var all_customers = await SP.Data.Customer.getCustomerInfos();

            for (let i = 0; i < all_customers.length; i++) {
                this.addCustomerButton(all_customers[i]);
            }

            this.initialized = true;
        }

        async open(barcode: string) {
            this.front_po_suggestion_container.innerHTML = "";

            await this.init();

            this.clear();

            this.result_barcode = barcode;
            if (barcode) {
                //var PurchaseOrders = await SP.Data.PurchaseOrder.getPurchaseOrders(this.result_customer, null, SP.PurchaseOrderState.Ordered, barcode);
                var PurchaseOrders = await SP.Data.PurchaseOrder.getBarcodeSearch(barcode);
                for (let i = 0; i < PurchaseOrders.length; i++) {
                    await this.addPurchaseOrder(PurchaseOrders[i], false);
                }
            }
            //show suggestion container and home screen
            this.open_home_menu();
        }

        close() {
            this.container.style.display = "none";
        }

        purchaseOrderButtons: HTMLElement[] = [];

        async addPurchaseOrder(po: SP.purchaseOrderInfo, stock_list: boolean = false) {
            console.log(po, stock_list);
            var ci = await SP.Data.Customer.getCustomerInfo(po.customerId, true);


            var c = document.createElement("div");
            if (stock_list) this.po_suggestion_container.appendChild(c);
            else this.front_po_suggestion_container.appendChild(c)
            c.classList.add("btn", "noselect");


            if (!stock_list) {
                c.innerHTML = `<span class="action">${po.purchaseOrderType == SP.PurchaseOrderType.PurchaseOrder ? "Purchase Order Arrival" : "Return Order Arrival"}</span><br>`;
            }

            c.innerHTML += `
                <span class="name"><b>${ci.customerName} / ${po.supplier.name} / ${po.referenceNo}</b></span><br>
                <span class="expected">${SP.Localize("sentance_order_lines")} <b>${po.lineCount}</b> | ${SP.Localize("sentance_items_delivered")} <b>${po.deliveredItems}/${po.itemsTotal}</b><br>
                ${SP.Localize("sentance_expected_delivery")} <b>${po.expectedDeliveryDate}</b>`;

            if (po.trackingNumbers) c.innerHTML += `<br>${SP.Localize("sentance_tracking_numbers")} <b>${po.trackingNumbers}</b>`;
            c.innerHTML += "</span>"

            c.addEventListener("click", () => {
                this.result_purchase_order = po;
                this.result_customer = po.customerId;
                this.result_sender = po.supplier.name;

                this.result_arrival_type = po.purchaseOrderType == SP.PurchaseOrderType.ReturnOrder ? SP.ArrivalType.Return : SP.ArrivalType.Standard;
                if (po.purchaseOrderType == SP.PurchaseOrderType.ReturnOrder) this.customer_name_input.value = po.supplier.name;


                //If more locations, open location menu



                if (po.locationInfos.length > 1) {
                    this.open_location_menu(po.locationInfos);
                }
                else {
                    this.result_arrival_location = po.locationInfos[0].location;
                    this.open_reference_menu();
                }

            });

            this.purchaseOrderButtons.push(c);
        }

        addLocationButton(name: string, key: string, itemCount: number, recievedCount: number) {
            var c = this.locations_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var locationName = c.appendChild(document.createElement("span"));
            locationName.classList.add("action");
            locationName.innerHTML = name + " ";

            var counts = c.appendChild(document.createElement("span"))
            counts.classList.add("label");
            counts.innerHTML = `(${recievedCount} / ${itemCount})`;

            if (recievedCount < itemCount) {
                counts.classList.add("label-warning");
            }



            c.addEventListener("click", () => {
                this.result_arrival_location = key;
                this.open_reference_menu();
            });

        }

        addSenderButton(name: string, value: string) {
            var c = this.sender_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = name;

            c.addEventListener("click", () => {
                this.result_sender = value;
                this.open_reference_menu();
            });

        }

        addCustomerButton(info: SP.CustomerInfo) {
            var c = this.stock_suggestion_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");


            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = info.customerName;

            c.addEventListener("click", () => {
                this.result_customer = info.customerId;
                this.open_po_menu();
            });
            this.stockButtons.push(c);
        }

        addArrivalButton() {
            var c = this.home_menu.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");
            c.style.marginTop = "30px";

            var icon = c.appendChild(document.createElement("img"));
            icon.src = "/terminal/img/icon/open-box.png";
            icon.classList.add("icon");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_arrival");

            c.appendChild(document.createElement("br"));

            var name = c.appendChild(document.createElement("span"));
            name.classList.add("name");
            name.innerHTML = SP.Localize("sentance_standard_arrival");

            c.addEventListener("click", () => {
                this.result_arrival_type = SP.ArrivalType.Standard;
                this.open_stock_menu();
            });
        }

        addReturnButton() {
            var c = this.home_menu.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var icon = c.appendChild(document.createElement("img"));
            icon.src = "/terminal/img/icon/return-box.png";
            icon.classList.add("icon");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_return");

            c.appendChild(document.createElement("br"));

            var name = c.appendChild(document.createElement("span"));
            name.classList.add("name");
            name.innerHTML = SP.Localize("sentance_customer_return_delivery");

            c.addEventListener("click", () => {
                this.result_arrival_type = SP.ArrivalType.Return;
                this.open_stock_menu();
            });
        }

        async addAuditButton() {
            var c = this.home_menu.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var icon = c.appendChild(document.createElement("img"));
            icon.src = "/terminal/img/icon/audit-box.png";
            icon.classList.add("icon");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("word_audit");

            c.appendChild(document.createElement("br"));

            var name = c.appendChild(document.createElement("span"));
            name.classList.add("name");
            name.innerHTML = SP.Localize("sentance_add_audit_item");

            c.addEventListener("click", () => {
                this.result_arrival_type = SP.ArrivalType.Audit;
                this.open_stock_menu();
            });
        }

        async addInternalReturnButton() {
            var c = this.home_menu.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            c.style.marginTop = "30px";

            var icon = c.appendChild(document.createElement("img"));
            icon.src = "/terminal/img/icon/return-box.png";
            icon.classList.add("icon");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = SP.Localize("sentance_internal_return");

            c.appendChild(document.createElement("br"));

            var name = c.appendChild(document.createElement("span"));
            name.classList.add("name");
            name.innerHTML = SP.Localize("sentance_return_items_to_warehouse");

            c.addEventListener("click", () => {
                this.result_arrival_type = SP.ArrivalType.InternalReturn;
                this.open_stock_menu();
            });
        }


    }


    class App_Arrival extends AppBase {
        arrivals: { [id: string]: ArrivalElement } = {};
        arrivals_sorted: ArrivalElement[] = [];
        active = document.getElementById("active_arrivals");
        finished = document.getElementById("finished_arrivals");
        assistant = new ArrivalAssistant();
        static instance: App_Arrival;

        constructor() {
            super("app_arrival");
            hub.on("arrivalAdded", (d) => this.arrivalAdded(d, true));
            hub.on("arrivalUpdated", (d) => this.arrivalUpdated(d));
            hub.on("arrivalDeleted", (d) => this.arrivalDeleted(d));
            App_Arrival.instance = this;

            document.getElementById("add_arrival_button").addEventListener("click", () => {
                this.assistant.open(null);
                //GetApp("app_arrival_create").open();
            });

            document.getElementById("return_package_button").addEventListener("click", () => {
                GetApp("app_return").open();
            });

            document.getElementById("transfer_package_button").addEventListener("click", () => {
                GetApp("app_receive_transfer").open();
            });

            container.appendChild(this.assistant.container);
        }

        bound = false;

        async onOpen() {
            //reset
            this.arrivals = {};
            this.arrivals_sorted = [];

            //load
            var arrivals = await SP.Data.Arrival.getArrivalInfos();
            arrivals.forEach((a) => {
                this.arrivalAdded(a, false);
            });

            this.render();

            if (!this.bound) {
                barcodeListener.on(null, this.scanBarcode, this);
                this.bound = true;
            }
        }



        async onClose() {
            this.assistant.close();

            if (this.bound) {
                barcodeListener.off(null, this.scanBarcode);
                this.bound = false;
            }
        }

        async scanBarcode(code: string) {
            this.assistant.open(code);
        }

        arrivalAdded(data: SP.ArrivalInfo, render: boolean) {
            var current = this.arrivals[data.arrivalId];
            if (current == null) {
                current = this.arrivals[data.arrivalId] = new ArrivalElement(data);
                this.arrivals_sorted.push(current);
            }

            if (render) this.render();
        }

        arrivalDeleted(data: SP.ArrivalInfo) {
            var current = this.arrivals[data.arrivalId];
            if (current != null) {
                this.arrivals_sorted.splice(this.arrivals_sorted.indexOf(current), 1);
                delete this.arrivals[data.arrivalId];
                current.html.remove();
            }
        }


        arrivalUpdated(data: SP.ArrivalInfo) {
            this.arrivalDeleted(data);
            this.arrivalAdded(data, true);
        }

        render() {
            //containers


            //sort
            this.arrivals_sorted.sort((a, b) => a.data.arrivalTimestamp < b.data.arrivalTimestamp ? 1 : -1);

            //clear
            this.active.innerHTML = "";
            this.finished.innerHTML = "";

            //append
            for (let i = 0; i < this.arrivals_sorted.length; i++) {
                let current = this.arrivals_sorted[i];
                if (current.data.arrivalFinished) this.finished.appendChild(current.html);
                else this.active.appendChild(current.html);
            }
        }
    }


    RegisterApp("app_arrival", App_Arrival);
}